import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";

export const getAuthAndMeQuery = gql`
  query {
    auth @client {
      isLoggedIn
      me {
        firstName
        lastName
      }
    }
  }
`;

export const GET_ME = gql`
  {
    me {
      firstName
      lastName
    }
  }
`;

export const getAuth = gql`
  query {
    auth @client {
      isLoggedIn
    }
  }
`;

export const getAuthAndMe = (query) =>
  graphql(query, {
    props: ({ data }) => ({
      data,
    }),
  });

export const getLoggedIn = (query) =>
  graphql(query, {
    props: ({ data }) => ({
      isLoggedIn: data.auth ? data.auth.isLoggedIn : false,
    }),
  });

export const getJobs = (query) =>
  graphql(query, {
    props: ({ data }) => ({
      data,
      loading: data.loading,
      error: data.error,
    }),
  });

export const JobPermissionsQuery = gql`
  query jobPermissions($contactId: ID!) {
    jobPermissions(contactId: $contactId) {
      id
      name
      officeId
    }
  }
`;

export const getMeUser = gql`
  query User {
    me {
      id
      primaryEmail
      type
      firstName
      lastName
      photo
      class
      type
      displayName
      role
      universalId
      canSeePgaProJob
    }
  }
`;

export const getMePersonId = gql`
  query me {
    me {
      id
      pgaId
    }
  }
`;

export const myJobPostsQuery = gql`
  query myJobPosts($input: MembershipMyJobsInput!) {
    myJobPosts(input: $input) {
      count
      jobs {
        id
        offices {
          id
          name
          city
          state
          zip
        }
        applicantGroup
        jobCategory
        jobTitle
        caseStatus
        employmentType
        yearsExperience
        submissionDeadline
        baseCompensation
        baseCompensationMax
        paySchedule
        additionalIncome
        totalCompensation
        contact {
          name
          title
          email
        }
        employer {
          id
          pgaId
        }
        education
        additionalPGAEducation
        applyVia
        website
        overview
        experienceRequired
        responsibilities
        benefits
        termOfServiceAgreement
        currentStep
        createdAt
        needsAssistance
        hideCompensation
        applicants {
          id
          contactId
          firstName
          lastName
          email
          resumeLink
          coverLetterLink
        }
        reviewRequestSent
        otherStates
      }
    }
  }
`;
